module.exports = __webpack_public_path__ + "static/bio-hero-4f8e74fe1c71e13d2f81b20165a9eb1a.jpg";